export function AgentCard({ type, onClick, currentType }) {
  return (
    <div className={`agent-card ${currentType === type ? 'active' : ''}`} onClick={() => onClick(type)}>
      <h3 className="font" style={{ fontSize: '50px', letterSpacing: '0.02em' }}>
        {type}
      </h3>
    </div>
  )
}
